import { ResetPasswordContainer } from "../../login/ui"

export default function Page(props) {
  return <ResetPasswordContainer {...props} />
}